<template>
  <div>
    <FunnelBreadcrumb />
    <div class="bg-surface-default-low flex justify-center md:py-32">
      <div class="flex h-full w-full flex-col justify-center p-24 md:w-[34rem]">
        <div
          class="border-static-default-low flex justify-center border-b-2 py-16"
        >
          <span class="body-1">
            {{ i18n(translations.headerTitle) }}
          </span>
        </div>
        <div class="flex flex-col justify-start pt-32">
          <span class="body-1-bold">
            {{ i18n(translations.formTitle) }}
          </span>
          <span class="body-1 my-16">
            {{ i18n(translations.formDescription, { price }) }}
          </span>

          <p v-if="apiErrors.error" class="text-action-danger-hi body-2 mt-12">
            {{ apiErrors.error }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { createError, useRouteParams, useRouter } from '#imports'
import { ref } from 'vue'

import { buybackCustomerAPI } from '@backmarket/http-api'
import { useHttpFetch } from '@backmarket/nuxt-module-http/useHttpFetch'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import { HOME } from '~/scopes/home/route-names'

import FunnelBreadcrumb from '../components/FunnelBreadcrumb/FunnelBreadcrumb.vue'

import translations from './Bank.translations'

const i18n = useI18n()
const price = ref(0)
const routeParams = useRouteParams()
const router = useRouter()
const apiErrors = ref<{
  error?: string
}>({})

const { data, error, status } = await useHttpFetch(
  buybackCustomerAPI.getOffer,
  {
    pathParams: { sourcingListingId: routeParams?.offerId },
  },
)

if (data.value === null && status.value === 'success') {
  router.push({ name: HOME })
}

if (error.value) {
  throw createError({
    statusCode: error.value.statusCode,
    statusMessage: error.value.message,
    fatal: true,
  })
}
</script>
